var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-btn thinly-shadowed",class:{ tutorial: _vm.showTutorial },on:{"click":_vm.showHelp}},[(_vm.helpShown)?_c('p',[_vm._v("OK")]):_c('img',{staticClass:"help-img",attrs:{"src":require("@/assets/img/utils/help.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }